import SvgIcon from 'components/Icon/SvgIcon'
import {
  ARUS_KAS,
  HISTORY_ARUS_KAS,
  URL_ADDRESS_BOOK,
  URL_ANNUAL_CAPACITY,
  URL_AP2HI_INSIGHT,
  URL_AP2HI_LOG,
  URL_APPROVAL_BUY,
  URL_ATTENDANCE,
  URL_ATTENDANCE_REPORT,
  URL_ATTENDANCE_REPORT_MEMBER,
  URL_ATTENDANCE_TODAY,
  URL_CATCHES,
  URL_CENTER_ATTENDANCE,
  URL_COMPANIES,
  URL_DASHBOARD_TRACEABILITY,
  URL_EMPLOYEE_PAYMENTS,
  URL_WAGE_SALARY,
  URL_EVENT,
  URL_FARMERS,
  URL_FINDORA_DASHBOARD,
  URL_FISHERIES,
  URL_FULFILMENT_REPORT,
  URL_GEARS,
  URL_HOMEPAGE,
  URL_INVENTORI_INTELLIGENCE,
  URL_INVENTORY,
  URL_INVENTORY_MEMBERS,
  URL_KURSUS,
  URL_LEARNIING_REPORT,
  URL_LIST_TRANSACTIONS,
  URL_TRANSACTION_SUMMARY,
  URL_MUTATION_REPORT,
  URL_PORTS,
  URL_PROCESSING_REPORT,
  URL_PROJECTS_MENU,
  URL_SESSION_PROCESS,
  URL_SPATIAL,
  URL_TRANSFER_INVENTORY,
  URL_UTANG,
  URL_VESSELS,
  URL_WAREHOUSE,
  URL_WHISTLE_BLOWINGS,
  URL_WORKPLACE,
  URL_QR_PRINTING,
} from 'utils/pathUrl'
import {
  BUSINESS_AR_AP,
  BUSINESS_ATTENDANCE_CENTER,
  BUSINESS_AR_AP_COMPANY,
  BUSINESS_ATTENDANCE_DASHBOARD,
  BUSINESS_ATTENDANCE_INPUT,
  BUSINESS_AUTOREPO,
  BUSINESS_BOOKKEEPING,
  BUSINESS_BOOKKEEPING_COMPANY,
  BUSINESS_COMPLIANCE_DASHBOARD,
  BUSINESS_EVENT,
  BUSINESS_EVENT_PARTICIPANT,
  BUSINESS_FARMERS,
  BUSINESS_FULFILMENT,
  BUSINESS_GRIEVANCE,
  BUSINESS_INVENTORY,
  BUSINESS_INVENTORY_MEMBER,
  BUSINESS_LEARNING,
  BUSINESS_LEARNING_REPORT,
  BUSINESS_MEMBER_DISTRIBUTION,
  BUSINESS_MYAPPROVAL,
  BUSINESS_PROCESS,
  BUSINESS_TALANGIN,
  BUSINESS_TOPUP,
  BUSINESS_TRANSACTION_PURCHASE,
  BUSINESS_TRANSACTION_SELL,
  BUSINESS_TRANSFER_INVENTORY,
  BUSINESS_VESSELS,
  BUSINESS_WAREHOUSE,
  BUSINESS_WITHDRAWAL,
  READ,
} from 'utils/subjectActions'

export const menus = [
  {
    headTitle: 'Beranda',
    action: READ,
    icon: (
      <SvgIcon name="old-icons-home" size={30} id="homepage" color="#667085" />
    ),
    isParent: true,
    path: URL_HOMEPAGE,
    subject: [
      BUSINESS_TALANGIN,
      BUSINESS_TOPUP,
      BUSINESS_TRANSACTION_PURCHASE,
      BUSINESS_TRANSACTION_SELL,
      BUSINESS_WITHDRAWAL,
      BUSINESS_FARMERS,
    ],
  },
  {
    headTitle: 'Transaksi',
    action: READ,
    icon: (
      <SvgIcon name="right-left" size={30} id="transaksi" color="#667085" />
    ),
    subject: [
      BUSINESS_TOPUP,
      BUSINESS_TRANSACTION_PURCHASE,
      BUSINESS_TRANSACTION_SELL,
      BUSINESS_WITHDRAWAL,
      BUSINESS_MYAPPROVAL,
    ],
    items: [
      // {
      //   title: 'Transaksi Aktif',
      //   icon: (
      //     <SvgIcon
      //       name="old-icons-home"
      //       size={30}
      //       id="beranda"
      //       color="#667085"
      //     />
      //   ),
      //   path: '/',
      //   action: READ,
      //   subject: [
      //     BUSINESS_TALANGIN,
      //     BUSINESS_TOPUP,
      //     BUSINESS_TRANSACTION_PURCHASE,
      //     BUSINESS_TRANSACTION_SELL,
      //     BUSINESS_WITHDRAWAL,
      //     BUSINESS_FARMERS,
      //   ],
      // },
      {
        title: 'Daftar Transaksi',
        icon: (
          <SvgIcon
            size={30}
            id="daftar-transaksi"
            color="#667085"
            name="file"
          />
        ),
        path: URL_LIST_TRANSACTIONS,
        action: READ,
        subject: [
          BUSINESS_TRANSACTION_PURCHASE,
          BUSINESS_TRANSACTION_SELL,
          BUSINESS_FARMERS,
        ],
      },
      {
        title: 'Ringkasan Transaksi',
        icon: (
          <SvgIcon
            size={30}
            id="ringkasan-transaksi"
            color="#667085"
            name="notes-2"
          />
        ),
        path: URL_TRANSACTION_SUMMARY,
        action: READ,
        subject: [
          BUSINESS_TRANSACTION_PURCHASE,
          BUSINESS_TRANSACTION_SELL,
        ],
      },
      {
        title: 'Persetujuan',
        icon: (
          <SvgIcon size={30} id="persetujuan" name="old-icons-check-circle" />
        ),
        path: URL_APPROVAL_BUY,
        action: READ,
        subject: [BUSINESS_MYAPPROVAL],
      },
      {
        title: 'Projects',
        icon: <SvgIcon name={'notes-2'} size={28} id="projects" />,
        path: URL_PROJECTS_MENU,
        action: READ,
        subject: [BUSINESS_INVENTORY],
      },
      {
        title: 'Employee Payments',
        icon: <SvgIcon name={'notes-2'} size={28} id="employee-payments" />,
        path: URL_EMPLOYEE_PAYMENTS,
        action: READ,
        subject: [BUSINESS_INVENTORY],
      },
      {
        title: 'Wage & Salary',
        icon: <SvgIcon name={'notes-2'} size={28} id="wage-salary" />,
        path: URL_WAGE_SALARY,
        action: READ,
        subject: [BUSINESS_INVENTORY],
      },
    ],
  },
  {
    headTitle: 'Dashboard',
    action: READ,
    icon: (
      <SvgIcon
        name="finance"
        size={30}
        id="dashboard-finance"
        color="#667085"
      />
    ),
    subject: [BUSINESS_COMPLIANCE_DASHBOARD, BUSINESS_INVENTORY],
    items: [
      {
        title: 'ESG',
        icon: <SvgIcon size={30} id="esg" color="#667085" name="file" />,
        path: URL_FINDORA_DASHBOARD,
        action: READ,
        subject: [BUSINESS_COMPLIANCE_DASHBOARD],
      },
      {
        title: 'Employee Overview',
        icon: (
          <SvgIcon
            size={30}
            id="employee-overview"
            color="#667085"
            name="file"
          />
        ),
        path: URL_ANNUAL_CAPACITY,
        action: READ,
        subject: [BUSINESS_COMPLIANCE_DASHBOARD],
      },
      {
        title: 'Inventory Intelligence',
        icon: (
          <SvgIcon
            size={30}
            id="inventori-intelligence"
            color="#667085"
            name="file"
          />
        ),
        path: URL_INVENTORI_INTELLIGENCE,
        action: READ,
        subject: [BUSINESS_COMPLIANCE_DASHBOARD],
      },
      // {
      //   title: 'Project Summary',
      //   icon: (
      //     <SvgIcon size={30} id="project-summary" color="#667085" name="file" />
      //   ),
      //   path: URL_PROJECT_SUMMARY_DASHBOARD,
      //   action: READ,
      //   subject: [BUSINESS_COMPLIANCE_DASHBOARD],
      // },
      {
        title: 'Dashboard Ketelusuran',
        icon: (
          <SvgIcon
            size={30}
            id="transfer-inventori"
            color="#667085"
            name={'old-icons-file-invoice'}
          />
        ),
        path: URL_DASHBOARD_TRACEABILITY,
        action: READ,
        subject: [BUSINESS_INVENTORY],
      },
    ],
  },
  {
    headTitle: 'Talangin',
    action: READ,
    icon: <SvgIcon name="card1" size={30} id="talangin" color="#667085" />,
    subject: [BUSINESS_TALANGIN, BUSINESS_AUTOREPO],
    items: [
      {
        title: 'Tagihan Talangin',
        icon: (
          <SvgIcon
            size={30}
            id="tagihan-talangin"
            name="file"
            color="#667085"
          />
        ),
        path: '/tagihan-talangin',
        action: READ,
        subject: [BUSINESS_TALANGIN],
      },
      {
        title: 'Repo Barang',
        icon: (
          <SvgIcon
            size={30}
            id="repo-komoditas"
            name="switch-vertical"
            color="#667085"
          />
        ),
        path: '/repo-komoditas',
        action: READ,
        subject: [BUSINESS_AUTOREPO],
      },
    ],
  },
  {
    headTitle: 'Manajemen Inventori',
    action: READ,
    icon: (
      <SvgIcon
        name="old-icons-box"
        size={30}
        id="manajemen-inventori"
        color="#667085"
      />
    ),
    subject: [
      BUSINESS_INVENTORY,
      BUSINESS_WAREHOUSE,
      BUSINESS_TRANSFER_INVENTORY,
    ],
    items: [
      {
        title: 'Inventori',
        icon: (
          <SvgIcon
            name={'old-icons-boxes'}
            color="#667085"
            size={30}
            id="inventori"
          />
        ),
        path: URL_INVENTORY,
        action: READ,
        subject: [BUSINESS_INVENTORY],
      },
      {
        title: 'Transfer Inventori',
        icon: (
          <SvgIcon
            size={30}
            id="transfer-inventori"
            color="#667085"
            name={'old-icons-truck'}
          />
        ),
        path: URL_TRANSFER_INVENTORY,
        action: READ,
        subject: [BUSINESS_TRANSFER_INVENTORY],
      },
      {
        title: 'Pemenuhan Order',
        icon: <SvgIcon name={'list'} size={28} id="fulfilment-report" />,
        path: URL_FULFILMENT_REPORT,
        action: READ,
        subject: [BUSINESS_FULFILMENT],
      },
      {
        title: 'Gudang',
        icon: (
          <SvgIcon
            size={30}
            id="gudang"
            color="#667085"
            name={'home-outline'}
          />
        ),
        path: URL_WAREHOUSE,
        action: READ,
        subject: [BUSINESS_WAREHOUSE],
      },
      {
        title: 'Laporan Ketelusuran',
        icon: (
          <SvgIcon
            size={30}
            id="transfer-inventori"
            color="#667085"
            name={'old-icons-file-invoice'}
          />
        ),
        path: URL_MUTATION_REPORT,
        action: READ,
        subject: [BUSINESS_INVENTORY],
      },
    ],
  },
  {
    headTitle: 'Manajemen Proses',
    action: READ,
    icon: (
      <SvgIcon
        name="transaction-filled"
        size={30}
        id="manajemen-proses"
        color="#667085"
      />
    ),
    subject: [BUSINESS_INVENTORY, BUSINESS_PROCESS],
    items: [
      {
        title: 'Proses',
        icon: (
          <SvgIcon
            name="old-icons-gears"
            size={30}
            id="proses"
            color="#667085"
          />
        ),
        path: URL_SESSION_PROCESS,
        action: READ,
        subject: [BUSINESS_PROCESS],
      },
      {
        title: 'Laporan Proses',
        icon: <SvgIcon name={'notes-2'} size={28} id="processing-report" />,
        path: URL_PROCESSING_REPORT,
        action: READ,
        subject: [BUSINESS_INVENTORY],
      },
    ],
  },
  {
    headTitle: 'Catatan Keuangan',
    action: READ,
    icon: <SvgIcon name="docs-pen" size={30} id="catatan" color="#667085" />,
    subject: [BUSINESS_AR_AP, BUSINESS_BOOKKEEPING, BUSINESS_LEARNING, BUSINESS_AR_AP_COMPANY, BUSINESS_BOOKKEEPING_COMPANY],
    items: [
      {
        title: 'Laporan Arus Kas',
        icon: (
          <SvgIcon
            name="old-icons-coins"
            size={30}
            id="arus-kas"
            color="#667085"
          />
        ),
        path: ARUS_KAS,
        action: READ,
        subject: [BUSINESS_BOOKKEEPING, BUSINESS_BOOKKEEPING_COMPANY],
      },
      {
        title: 'Riwayat Arus Kas',
        icon: (
          <SvgIcon
            name="weight"
            size={30}
            id="riwayat-arus-kas"
            color="#667085"
          />
        ),
        path: HISTORY_ARUS_KAS,
        action: READ,
        subject: [BUSINESS_BOOKKEEPING, BUSINESS_BOOKKEEPING_COMPANY],
      },
      {
        title: 'Utang Piutang',
        icon: <SvgIcon name="utang" size={30} id="utang" color="#667085" />,
        path: URL_UTANG,
        action: READ,
        subject: [BUSINESS_AR_AP, BUSINESS_AR_AP_COMPANY],
      },
      // {
      //   title: 'Piutang',
      //   icon: <SvgIcon name="piutang" size={30} id="piutang" color="#667085" />,
      //   path: URL_PIUTANG,
      //   action: READ,
      //   subject: [BUSINESS_AR_AP],
      // },
      {
        title: 'Kursus',
        icon: (
          <SvgIcon
            name="old-icons-book"
            size={30}
            id="kursus"
            color="#667085"
          />
        ),
        path: URL_KURSUS,
        action: READ,
        subject: [BUSINESS_LEARNING],
      },
    ],
  },
  {
    headTitle: 'Manajemen Anggota',
    icon: (
      <SvgIcon
        name="old-icons-user-friends"
        color="#667085"
        size={30}
        id="manajemen-anggota"
      />
    ),
    action: READ,
    subject: [
      BUSINESS_FARMERS,
      BUSINESS_MEMBER_DISTRIBUTION,
      BUSINESS_INVENTORY_MEMBER,
      BUSINESS_ATTENDANCE_DASHBOARD,
    ],
    items: [
      {
        title: 'Daftar Anggota',
        icon: (
          <SvgIcon
            size={30}
            id="daftar-anggota"
            name="old-icons-user-friends"
            color="#667085"
          />
        ),
        path: URL_FARMERS,
        action: READ,
        subject: [BUSINESS_FARMERS],
      },
      {
        title: 'Inventori Anggota',
        icon: (
          <SvgIcon
            size={30}
            id="inventori-anggota"
            name="old-icons-boxes"
            color="#667085"
          />
        ),
        path: URL_INVENTORY_MEMBERS,
        action: READ,
        subject: [BUSINESS_INVENTORY_MEMBER],
      },
      {
        title: 'Persebaran Anggota',
        icon: (
          <SvgIcon
            size={30}
            id="persebaran-anggota"
            name="maps"
            color="#667085"
          />
        ),
        path: URL_SPATIAL,
        action: READ,
        subject: [BUSINESS_MEMBER_DISTRIBUTION],
      },
      {
        title: 'Laporan Pembelajaran',
        icon: (
          <SvgIcon
            size={30}
            id="laporan-pembelajaran"
            name="file"
            color="#667085"
          />
        ),
        path: URL_LEARNIING_REPORT,
        action: READ,
        subject: [BUSINESS_LEARNING_REPORT],
      },
      // {
      //   title: 'Peran dan Hak Akses',
      //   icon: <Settings size={30} id="peran-dan-hak-akses" />,
      //   path: URL_ACCESS_ROLE,
      //   action: READ,
      //   subject: BUSINESS_FARMERS,
      // },
      {
        title: 'Laporan Absensi Anggota',
        icon: (
          <SvgIcon
            size={30}
            id="laporan-absensi-anggota"
            name="file"
            color="#667085"
          />
        ),
        path: URL_ATTENDANCE_REPORT_MEMBER,
        action: READ,
        subject: [BUSINESS_ATTENDANCE_DASHBOARD],
      },
    ],
  },
  {
    headTitle: 'Absensi',
    icon: (
      <SvgIcon
        name="old-icons-user-friends"
        size={30}
        id="absensi"
        color="#667085"
      />
    ),
    action: READ,
    subject: [
      BUSINESS_ATTENDANCE_DASHBOARD,
      BUSINESS_ATTENDANCE_INPUT,
      BUSINESS_ATTENDANCE_CENTER,
    ],
    items: [
      {
        title: 'Absensi',
        icon: (
          <SvgIcon
            name="old-icons-profile"
            size={30}
            id="absensi"
            color="#667085"
          />
        ),
        action: READ,
        path: URL_ATTENDANCE,
        subject: [BUSINESS_ATTENDANCE_INPUT],
      },
      {
        title: 'Absensi Center',
        icon: (
          <SvgIcon
            name="old-icons-profile"
            size={30}
            id="absensi"
            color="#667085"
          />
        ),
        action: READ,
        path: URL_CENTER_ATTENDANCE,
        subject: [BUSINESS_ATTENDANCE_CENTER],
      },
      {
        title: 'Ringkasan',
        icon: <SvgIcon size={30} id="ringkasan" name="list" color="#667085" />,
        path: URL_ATTENDANCE_REPORT,
        action: READ,
        subject: [BUSINESS_ATTENDANCE_DASHBOARD],
      },
      {
        title: 'Laporan Hari Ini',
        icon: (
          <SvgIcon
            size={30}
            id="laporan-hari-ini"
            name="file"
            color="#667085"
          />
        ),
        path: URL_ATTENDANCE_TODAY,
        action: READ,
        subject: [BUSINESS_ATTENDANCE_DASHBOARD],
      },
    ],
  },
  {
    headTitle: 'Operasi AP2HI',
    action: READ,
    icon: (
      <SvgIcon name="fish-ap2hi" size={30} id="operasi-ap2hi" color="#667085" />
    ),
    subject: [BUSINESS_VESSELS],
    items: [
      {
        title: 'Perjalanan',
        icon: (
          <SvgIcon
            name="fish-ap2hi"
            size={30}
            id="perjalanan"
            color="#667085"
          />
        ),
        path: URL_CATCHES,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
      {
        title: 'Log History',
        icon: (
          <SvgIcon name="list" size={30} id="log-history" color="#667085" />
        ),
        path: URL_AP2HI_LOG,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
      {
        title: 'Laporan Tangkapan',
        icon: (
          <SvgIcon
            name="finance"
            size={30}
            id="laporan-tangkapan"
            color="#667085"
          />
        ),
        path: URL_AP2HI_INSIGHT,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
    ],
  },
  {
    headTitle: 'Master Data',
    action: READ,
    icon: (
      <SvgIcon name="data-stack" size={30} id="master-data" color="#667085" />
    ),
    subject: [BUSINESS_VESSELS],
    items: [
      {
        title: 'Vessel',
        icon: (
          <SvgIcon
            name="old-icons-ship"
            size={30}
            id="vessel"
            color="#667085"
          />
        ),
        path: URL_VESSELS,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
      {
        title: 'Port',
        icon: (
          <SvgIcon
            name="icon-ports-converted"
            size={30}
            id="port"
            color="#667085"
          />
        ),
        path: URL_PORTS,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
      {
        title: 'Gear',
        icon: (
          <SvgIcon name="old-icons-cog" size={30} id="gear" color="#667085" />
        ),
        path: URL_GEARS,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
      {
        title: 'Fishery',
        icon: (
          <SvgIcon
            name="icon-fisheries-converted"
            size={30}
            id="fishery"
            color="#667085"
          />
        ),
        path: URL_FISHERIES,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
      {
        title: 'Company',
        icon: (
          <SvgIcon
            name="icon-companies"
            size={30}
            id="company"
            color="#667085"
          />
        ),
        path: URL_COMPANIES,
        action: READ,
        subject: [BUSINESS_VESSELS],
      },
    ],
  },
  {
    headTitle: 'Event',
    action: READ,
    icon: <SvgIcon name="docs-pen" size={30} id="catatan" color="#667085" />,
    subject: [
      BUSINESS_EVENT,
      BUSINESS_EVENT_PARTICIPANT,
      // BUSINESS_EVENT_PARTNER,
    ],
    items: [
      {
        title: 'Event',
        icon: (
          <SvgIcon name="docs-pen" size={30} id="arus-kas" color="#667085" />
        ),
        path: URL_EVENT,
        action: READ,
        subject: [BUSINESS_EVENT],
      },
      // {
      //   title: 'Partner Event',
      //   icon: (
      //     <SvgIcon name="docs-pen" size={30} id="arus-kas" color="#667085" />
      //   ),
      //   path: URL_EVENT_PARTNER,
      //   action: READ,
      //   subject: [BUSINESS_EVENT_PARTNER],
      // },
      // {
      //   title: 'Peserta Event',
      //   icon: (
      //     <SvgIcon name="docs-pen" size={30} id="arus-kas" color="#667085" />
      //   ),
      //   path: URL_EVENT_PARTICIPANT,
      //   action: READ,
      //   subject: [BUSINESS_EVENT_PARTICIPANT],
      // },
    ],
  },
  {
    headTitle: 'Daftar Kontak',
    icon: (
      <SvgIcon
        name="old-icons-book"
        size={30}
        id="daftar-kontak"
        color="#667085"
      />
    ),
    isParent: true,
    path: URL_ADDRESS_BOOK,
  },
  {
    headTitle: 'Pengaduan',
    icon: (
      <SvgIcon name="icon-report" size={30} id="pengaduan" color="#667085" />
    ),
    path: URL_WHISTLE_BLOWINGS,
    action: READ,
    subject: [BUSINESS_GRIEVANCE],
    isParent: true,
  },
  {
    headTitle: 'Alat Bantu',
    icon: (
      <SvgIcon
        name="old-icons-wrench"
        size={30}
        id="alat-bantu"
        color="#667085"
      />
    ),
    isParent: true,
    path: URL_WORKPLACE,
    action: READ,
    subject: [BUSINESS_BOOKKEEPING],
  },
]
